/**
 * Accept-invite link: /accept-invite?w=<workspaceId>&t=<inviteId>
 * Optional e= and n= so the logged-out page can name the brain and lock the email.
 * Uses the current site when we are on http(s). On Electron file://, fall
 * back to the matching hosted app so the copied link works for someone else.
 */

export function buildAcceptInviteUrl(workspaceId, inviteId, extra = {}) {
  const params = new URLSearchParams();
  params.set('w', String(workspaceId || ''));
  params.set('t', String(inviteId || ''));
  const email = String(extra.email || '').trim().toLowerCase();
  if (email) params.set('e', email);
  const workspaceName = String(extra.workspaceName || '').trim().slice(0, 64);
  if (workspaceName) params.set('n', workspaceName);
  const path = `/accept-invite?${params.toString()}`;
  if (typeof window === 'undefined') return path;
  const { protocol, origin } = window.location;
  if (protocol === 'http:' || protocol === 'https:') {
    return `${origin}${path}`;
  }
  const host =
    process.env.REACT_APP_ENV === 'production'
      ? 'https://fokus.plet.ai'
      : 'https://fokus-staging.plet.ai';
  return `${host}${path}`;
}

export function parseAcceptInviteSearch(searchParams) {
  const get = (key) => {
    if (!searchParams) return '';
    if (typeof searchParams.get === 'function') return searchParams.get(key) || '';
    return searchParams[key] || '';
  };
  return {
    workspaceId: String(get('w') || '').trim(),
    inviteId: String(get('t') || '').trim(),
    email: String(get('e') || '').trim().toLowerCase(),
    workspaceName: String(get('n') || '').trim().slice(0, 64),
  };
}
